import React, { lazy, Suspense } from 'react';

const LazyPreviousOrderPrintedMaterials = lazy(() => import('./PreviousOrderPrintedMaterials'));

const PreviousOrderPrintedMaterials = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyPreviousOrderPrintedMaterials {...props} />
  </Suspense>
);

export default PreviousOrderPrintedMaterials;
